import { MatchSet } from "model/Match/Set/MatchSet";
import { TimeAttackSetViewer } from "./TimeAttackSetViewer";
import { MatchViewerTracks } from "./TrackStats/MatchViewerTracks";
import { MatchTeams } from "model/Match/MatchTeams";
import { EmptyGrowPanelText } from "styles/text";
import { hasScore } from "model/Scores";
import { Panel } from "components/Panel/Panel";

interface Props {
  matchId: string;
  tournamentId: string;
  set: MatchSet;
  teams: MatchTeams;
}

export const MatchSetViewer = ({
  matchId,
  tournamentId,
  set,
  teams,
}: Props) => {
  const noTrackData = set.tracks.length === 0 && hasScore(set.scores);

  return (
    <>
      {noTrackData ? (
        <Panel>
          <EmptyGrowPanelText>No Track Data Available</EmptyGrowPanelText>
        </Panel>
      ) : set.type === "TimeAttack" ? (
        <TimeAttackSetViewer
          matchId={matchId}
          tournamentId={tournamentId}
          set={set}
          teams={teams}
        />
      ) : (
        <Panel padding="padded">
          <MatchViewerTracks
            set={set}
            matchId={matchId}
            tournamentId={tournamentId}
            teams={teams}
          />
        </Panel>
      )}
    </>
  );
};
